import { logger } from '../hlsjs/utils/logger';
import EME from './EME';

class LegacyEME extends EME {
	constructor(hls, keySystem, obtainKeySystemConfigCallback, video, totalSessions) {
		logger.log(`LegacyEME: constructor`);

		super(hls, keySystem, obtainKeySystemConfigCallback, totalSessions);

		this._options = null;
		this._ensurePromise = null;
		this._video = video;
		this._sessions = [];

		this._mediaKeys = window.WebKitMediaKeys || window.MSMediaKeys || window.WEBKITMediaKeys;

		if(this._mediaKeys === window.MSMediaKeys) {
			this._prefix = 'ms';
			//this._mediaKeys = window.MSMediaKeys;
		}
		else if(this._mediaKeys === window.WebKitMediaKeys || window.WEBKITMediaKeys) {
			this._prefix = 'webkit';
			//this._mediaKeys = window.WebKitMediaKeys;
		}
		else {
			this.onError({ message: 'no legacy mediaKeys object found' });
		}

		this.needkey = this.onNeedKey.bind(this);
		this.keymessage = this.onKeyMessage.bind(this);
		this.keyerror = this.onKeyError.bind(this);
		this.keyadded = this.onKeyAdded.bind(this);

		this._video.addEventListener(this._prefix + 'needkey', this.needkey);
	}

	dispose() {
		if(this._video) {
			this._video.removeEventListener(this._prefix + 'needkey', this.needkey);
			this._video = null;
		}

		while(this._sessions.length > 0) {
			let session = this._sessions.shift();
			session.removeEventListener(this._prefix + 'keymessage', this.keymessage);
			session.removeEventListener(this._prefix + 'keyerror', this.keyerror);
			session.removeEventListener(this._prefix + 'keyadded', this.keyadded);
		}

		this._options = null;
	}

	setOptions(options) {
		this._options = options;
	}

	set initData(initData) {
		this._initData = initData;
	}

	onKeyMessage(event) {
		let strMessage = String.fromCharCode.apply(null, event.message);

		logger.log(`createSession: keyMessage`);

		if(strMessage === 'certificate') {
			logger.log(`createSession: obtainCertificate`);
			this.obtainCertificate(event);
		}
		else {
			logger.log(`createSession: obtainLicense`);
			this.obtainLicense(event);
		}
	}

	onKeyError(event) {
		this.onError(event);
	}

	onKeyAdded(/*event*/) {
		logger.log(`onKeyAdded: key added`);
	}

	createSession(data, keys) {
		logger.log(`createSession`);
		let session = null;
		let initData = data;

		if(this._initData) {
			//TODO: extract the kid from the tenc atom
			//and lookup the kid in the initData map
			//alternatively we could just generate the initData directly from the tenc atom??
			initData = this._initData;
		}

		try {
			session = keys.createSession('video/mp4', initData);
			session.addEventListener(this._prefix + 'keymessage', this.keymessage);
			session.addEventListener(this._prefix + 'keyerror', this.keyerror);
			session.addEventListener(this._prefix + 'keyadded', this.keyadded);
			logger.log(`createSession: session created`);

		}
		catch(err) {
			logger.log(`createSession: failed to create the session`);
			this.onError(err);
		}
	}

	onNeedKey(event) {
		if(!this._video.msKeys && !this._video.webkitKeys) {
			logger.log(`onNeedKey`);
			try {
				let keys = new this._mediaKeys(this.keySystem);

				if(keys) {
					if(this._prefix === 'ms') {
						this._video.msSetMediaKeys(keys);
					}
					else if(this._prefix === 'webkit') {
						this._video.webkitSetMediaKeys(keys);
					}
					else {
						this.onError({ message: 'unsupported keySystem ' + this.keySystem });
					}

					this.createSession(event.initData, this._video.msKeys ? this._video.msKeys : this._video.webkitKeys);
				}
				else {
					this.onError({ message: 'failed to create media keys' });
				}
			}
			catch (e) {
				this.onError(e);
			}
		}
	}
}

export default LegacyEME;



// WEBPACK FOOTER //
// ./src/drm/LegacyEME.js